import React from "react";

import { ManifestIntegrationProvider } from "src/api/connectApi/manifestTypes";
import {
  Connection,
  LegacyIntegrationProvider,
} from "src/api/connectApi/types";
import { ApiEndpointsDisplay } from "src/connections/config/ApiEndpointsDisplay";
import {
  getLegacyApiEndpoints,
  getManifestDisplayData,
} from "src/connections/utils/apiEndpoints";

type ApiEndpointsAccordionLegacyProps = {
  variant: "legacy";
  connection: Connection | undefined;
  provider: LegacyIntegrationProvider;
};

type ApiEndpointsAccordionManifestProps = {
  variant: "manifest";
  manifest: ManifestIntegrationProvider;
};

export type ApiEndpointsAccordionProps =
  | ApiEndpointsAccordionLegacyProps
  | ApiEndpointsAccordionManifestProps;

// "View API Endpoints" accordion for legacy and manifest connections.
export const ApiEndpointsAccordion: React.FC<ApiEndpointsAccordionProps> = (
  props,
) => {
  const endpoints =
    props.variant === "legacy"
      ? getLegacyApiEndpoints(
          props.provider,
          props.connection?.resource_configs?.map((rc) => ({
            resource: rc.resource,
            name: rc.name,
          })),
        )
      : getManifestDisplayData(props.manifest);

  return <ApiEndpointsDisplay endpoints={endpoints} />;
};
